import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'experienceLevels';
export const experienceLevelsActions = makeActions(MODEL_NAME,'id','experience-levels');

export const getAllExperienceLevels = experienceLevelsActions.getAll;
export const editExperienceLevels = experienceLevelsActions.edit;
export const createExperienceLevels = experienceLevelsActions.create;
export const getByIdExperienceLevels = experienceLevelsActions.getDataById;
